import { render, staticRenderFns } from "./DemoAlertElevation.vue?vue&type=template&id=acf199ce&"
import script from "./DemoAlertElevation.vue?vue&type=script&lang=js&"
export * from "./DemoAlertElevation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VAlert,VSlider})
